export default [
    {
        path: '/exam/',
        component: (resolve) => require(['@/components/exam/Index'],resolve),
        meta: {
            title:'题库',
        }
    },
    {
        path: '/exam/choose',
        component: (resolve) => require(['@/components/exam/choose'],resolve),
        meta: {
            title:'选择考试',
        }
    },
    {
        path: '/exam/ranking',
        component: (resolve) => require(['@/components/exam/ranking'],resolve),
        meta: {
            title:'排行榜',
        }
    },
    {
        path: '/exam/simulate-paper',
        component: (resolve) => require(['@/components/exam/simulatePaper'],resolve),
        meta: {
            title:'模拟套卷',
        }
    },
    {
        path: '/exam/paper-content',
        component: (resolve) => require(['@/components/exam/paperContent'],resolve),
        meta: {
            title:'套卷详情',
        }
    },
    {
        path: '/exam/history',
        component: (resolve) => require(['@/components/exam/history'],resolve),
        meta: {
            title:'历史记录',
        }
    },
    {
        path: '/exam/exercise',
        component: (resolve) => require(['@/components/exam/exercise'],resolve),
        meta: {
            title:'做题页面',
        }
    },
    {
        path: '/exam/paper-report',
        component: (resolve) => require(['@/components/exam/paperReport'],resolve),
        meta: {
            title:'练习报告',
        }
    },
    {
        path: '/exam/parsing',
        component: (resolve) => require(['@/components/exam/parsing'],resolve),
        meta: {
            title:'解析页面',
        }
    },
    {
        path: '/exam/chapter',
        component: (resolve) => require(['@/components/exam/chapter'],resolve),
        meta: {
            title:'章节练习',
        }
    },
    {
        path: '/exam/wrong-topic',
        component: (resolve) => require(['@/components/exam/wrongTopic'],resolve),
        meta: {
            title:'错题本',
        }
    },
    {
        path: '/exam/collection',
        component: (resolve) => require(['@/components/exam/collection'],resolve),
        meta: {
            title:'收藏',
        }
    },
    {
        path: '/exam/mold-test',
        component: (resolve) => require(['@/components/exam/moldTest'],resolve),
        meta: {
            title:'模考',
        }
    },
    {
        path: '/exam/mold-test-list',
        component: (resolve) => require(['@/components/exam/moldTestList'],resolve),
        meta: {
            title:'模考列表',
        }
    },
    {
        path: '/exam/mold-test-detail',
        component: (resolve) => require(['@/components/exam/moldTestDetail'],resolve),
        meta: {
            title:'模考详情',
        }
    },
    {
        path: '/exam/correct-list',
        component: (resolve) => require(['@/components/exam/correctList'],resolve),
        meta: {
            title:'纠错记录',
        }
    },
    {
        path: '/exam/tips-list',
        component: (resolve) => require(['@/components/exam/tipsList'],resolve),
        meta: {
            title:'考试心得列表',
        }
    },
    {
        path: '/exam/random-exercise',
        component: (resolve) => require(['@/components/exam/randomExercise'],resolve),
        meta: {
            title:'随机练习做题页面',
        }
    },
    {
        path: '/exam/random-paper-report',
        component: (resolve) => require(['@/components/exam/randomPaperReport'],resolve),
        meta: {
            title:'随机练习练习报告',
        }
    },
    {
        path: '/exam/chapter-exercise',
        component: (resolve) => require(['@/components/exam/chapterExercise'],resolve),
        meta: {
            title:'章节练习做题页面',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/exam.js